import {
    ComparativeMetric,
    ComparativeNormalization,
    ComparativePeriodInfo,
    ComparativeRankItem
} from "@dropDesk/domain/entities/reports/report_ticket_comparative/comparative_metric.entity";
import {FeaturedAttendant} from "@dropDesk/domain/entities/reports/report_ticket_comparative/featured_attendant.entity";

export class ComparativeTexts {
    summary!: string;
    sectorsHighlight!: string;
    problemsHighlight!: string;
    clientsHighlight!: string;
    attendantsHighlight!: string;
    attendantsNote!: string;

    static fromJson(json: Record<string, any>): ComparativeTexts {
        return new ComparativeTexts({
            summary: json['summary'] as string,
            sectorsHighlight: json['sectorsHighlight'] as string,
            problemsHighlight: json['problemsHighlight'] as string,
            clientsHighlight: json['clientsHighlight'] as string,
            attendantsHighlight: json['attendantsHighlight'] as string,
            attendantsNote: json['attendantsNote'] as string,
        });
    }

    constructor({
        summary,
        sectorsHighlight,
        problemsHighlight,
        clientsHighlight,
        attendantsHighlight,
        attendantsNote
    }: {
        summary: string;
        sectorsHighlight: string;
        problemsHighlight: string;
        clientsHighlight: string;
        attendantsHighlight: string;
        attendantsNote: string;
    }) {
        Object.assign(this, {
            summary,
            sectorsHighlight,
            problemsHighlight,
            clientsHighlight,
            attendantsHighlight,
            attendantsNote
        });
    }
}

export class ComparativeMetricsGroup {
    timeFirstResponse!: ComparativeMetric;
    timeResolution!: ComparativeMetric;
    totalTickets!: ComparativeMetric;
    averagePerUnit!: ComparativeMetric;
    averageRating!: ComparativeMetric;
    ticketsInBusinessHour!: ComparativeMetric;
    ticketsOutBusinessHour!: ComparativeMetric;

    static fromJson(json: Record<string, any>): ComparativeMetricsGroup {
        return new ComparativeMetricsGroup({
            timeFirstResponse: ComparativeMetric.fromJson(json['timeFirstResponse']),
            timeResolution: ComparativeMetric.fromJson(json['timeResolution']),
            totalTickets: ComparativeMetric.fromJson(json['totalTickets']),
            averagePerUnit: ComparativeMetric.fromJson(json['averagePerUnit']),
            averageRating: ComparativeMetric.fromJson(json['averageRating']),
            ticketsInBusinessHour: ComparativeMetric.fromJson(json['ticketsInBusinessHour']),
            ticketsOutBusinessHour: ComparativeMetric.fromJson(json['ticketsOutBusinessHour']),
        });
    }

    constructor(props: {
        timeFirstResponse: ComparativeMetric;
        timeResolution: ComparativeMetric;
        totalTickets: ComparativeMetric;
        averagePerUnit: ComparativeMetric;
        averageRating: ComparativeMetric;
        ticketsInBusinessHour: ComparativeMetric;
        ticketsOutBusinessHour: ComparativeMetric;
    }) {
        Object.assign(this, props);
    }
}

export class ReportTicketComparativeEntity {
    period!: ComparativePeriodInfo;
    comparePeriod!: ComparativePeriodInfo;
    normalization!: ComparativeNormalization;
    metrics!: ComparativeMetricsGroup;
    sectors!: ComparativeRankItem[];
    descriptionStatics!: ComparativeRankItem[];
    clients!: ComparativeRankItem[];
    featuredAttendants!: FeaturedAttendant[];
    texts!: ComparativeTexts;

    static fromJson(json: Record<string, any>): ReportTicketComparativeEntity {
        return new ReportTicketComparativeEntity({
            period: ComparativePeriodInfo.fromJson(json['period']),
            comparePeriod: ComparativePeriodInfo.fromJson(json['comparePeriod']),
            normalization: json['normalization'] as ComparativeNormalization,
            metrics: ComparativeMetricsGroup.fromJson(json['metrics']),
            sectors: (json['sectors'] as Array<Record<string, any>>).map((entry) => ComparativeRankItem.fromJson(entry)),
            descriptionStatics: (json['descriptionStatics'] as Array<Record<string, any>>).map((entry) => ComparativeRankItem.fromJson(entry)),
            clients: (json['clients'] as Array<Record<string, any>>).map((entry) => ComparativeRankItem.fromJson(entry)),
            featuredAttendants: (json['featuredAttendants'] as Array<Record<string, any>>).map((entry) => FeaturedAttendant.fromJson(entry)),
            texts: ComparativeTexts.fromJson(json['texts']),
        });
    }

    constructor(props: {
        period: ComparativePeriodInfo;
        comparePeriod: ComparativePeriodInfo;
        normalization: ComparativeNormalization;
        metrics: ComparativeMetricsGroup;
        sectors: ComparativeRankItem[];
        descriptionStatics: ComparativeRankItem[];
        clients: ComparativeRankItem[];
        featuredAttendants: FeaturedAttendant[];
        texts: ComparativeTexts;
    }) {
        Object.assign(this, props);
    }
}
